import React from 'react'

function TenderTextLouver() {
  return (
    <embed src="\pdfs\EA2.3.1_ld-j_08.2013-kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextLouver